module.exports = __webpack_public_path__ + "bin/95d2ac8ecac4e16d2345d51bbee4216b.png";